export default __webpack_public_path__ + "static/media/32.059e8691.png";